import { Container } from 'semantic-ui-react';

import { parseCategory } from '../../helpers';

import styles from './Category.module.less';

const Category = (props) => {
  const { content } = props;

  if (!content?.category) return null;

  return (
    <Container className={styles.root}>
      <div className="label">Categorias</div>
      <div>{parseCategory(content.category)}</div>
    </Container>
  );
};

export default Category;
